import React from "react";
import { useIntl } from "react-intl";
import { AEButton } from "../buttons";

const FeedActionButtons = ({ setSelectedFeed, handleSubmit }) => {
  const { formatMessage } = useIntl();
  return (
    <>
      <AEButton
        variant={"primary"}
        size={"sm"}
        additionalClassName="mr-3"
        onClick={() => handleSubmit()}
      >
        {formatMessage({ id: "SAVE" })}
      </AEButton>
      <AEButton
        variant={"secondary"}
        size={"sm"}
        onClick={() => setSelectedFeed(null)}
      >
        {formatMessage({ id: "CANCEL" })}
      </AEButton>
    </>
  );
};

export default FeedActionButtons;
